import React from 'react';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { CharitableGoalDataDTO } from '../../CharitableGiving.meta';
import { CharitableGivingOptions } from '../../../../api/useGoalsQuery';
import { Select } from '../../../../../../CommonComponents/OPL/Select/Select/Select';

interface Props {
  options: CharitableGivingOptions;
}

export const CharityName = ({ options }: Props) => {
  const { control, formState } = useFormContext<CharitableGoalDataDTO>();

  const { charityNameOptions } = options;

  return (
    <Controller
      control={control}
      name="charityName"
      render={({ field: { value, onChange, disabled } }) => {
        return (
          <Select
            isCreatable
            isPortal
            isClearable
            value={value ? { label: value, value } : null}
            options={charityNameOptions}
            onChange={opt => {
              onChange(opt?.value ?? null);
            }}
            onCreateOption={opt => {
              if (opt) {
                onChange(opt);
              }
            }}
            aria-label="Select or add a Charity"
            label="Select or add a Charity"
            placeholder="Select or add a Charity"
            noOptionsMessage={() => 'Please enter a charity name'}
            formatCreateLabel={createValue => `Add ${createValue}`}
            formVariant={formState.errors.charityName ? 'error' : undefined}
            helperText={(formState.errors.charityName as FieldError)?.message}
            disabled={disabled}
          />
        );
      }}
    />
  );
};
